import { useState } from "react";

import { CloseIcon } from "../../assets/accountIcons";
import { SearchIcon } from "../../assets/icons";
import {
  AccountProps,
  ButtonProps,
  InputProps,
  ModalProps,
  SelectProp,
  TitleSubtitleTypes,
} from "./types";

export const AccountContainer = ({ children, headerText }: AccountProps) => {
  return (
    <div className="col-6 rounded-lg p-6 border border-border-border1 dark:border-tabs dark:bg-BG-dark">
      <span className="satoshi-xl-bold-pry-900 dark:text-white">
        {headerText}
      </span>
      {children}
    </div>
  );
};

export const ExternalContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className="px-4 pt-6 pb-2 bp:p-0">{children}</div>;
};

export const Button = ({
  text,
  width = "w-fit",
  disabled,
  onClick,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${width} py-3 px-5 rounded-lg satoshi-base-bold-sec-900 dark:text-white border border-border-light dark:border-border-border1`}
    >
      {text}
    </button>
  );
};

export const Input = ({
  value,
  placeholder,
  type,
  register,
  name,
  disabled,
}: InputProps) => {
  return (
    <div className="relative">
      <input
        id={value}
        type={type}
        {...(register && name ? register(name) : {})}
        name={name}
        {...(disabled ? { disabled: true } : {})}
        className="peer h-12 w-full border border-inputBorder p-3 dark:bg-white/10 rounded-lg satoshi-base-medium-black  placeholder-transparent focus:outline-none focus:border-black"
        placeholder={placeholder}
        value={value}
      />
      <label
        htmlFor={value}
        className="absolute bg-white left-3.5 -top-2.5 px-1 peer-focus:bg-white peer-focus:dark:bg-inherit satoshi-sm-medium-black transition-all  peer-placeholder-shown:text-base peer-placeholder-shown:text-black peer-placeholder-shown:top-3 peer-focus:-top-2.5 peer-focus:text-black peer-focus:text-sm"
      >
        {placeholder}
      </label>
    </div>
  );
};

export const Select = ({ data, label, value }: SelectProp) => {
  return (
    <div className="relative">
      <select
        className="peer h-12 w-full border border-inputBorder p-3 rounded-lg dark:bg-white/10 satoshi-base-medium-white placeholder-transparent focus:outline-none focus:border-black"
        id="select"
        value={value}
      >
        {data.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {/* <label
        htmlFor="select"
        className="absolute left-3.5 -top-2.5 px-1 satoshi-sm-medium-inputBorder transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3 peer-focus:-top-2.5 peer-focus:text-inputBorder peer-focus:text-sm"
      >
        {label}
      </label> */}
    </div>
  );
};

export const TitleSubtitle = ({ title, subtitle }: TitleSubtitleTypes) => {
  return (
    <div className="flex flex-col gap-[2px]">
      <span className="lt-base-semibold-toggleBG-dark dark:text-white">
        {title}
      </span>
      <span className="lt-sm-normal-tabs dark:text-main-dark">{subtitle}</span>
    </div>
  );
};

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-24 px-4 bg-black/80">
      <div className="relative bg-white min-w-72 bp:min-w-96 dark:bg-black rounded-lg shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-gray-600 hover:text-gray-900"
        >
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>
  );
};

export const MMSearch = ({ value }: { value: string }) => {
  const [inputValue, setInputValue] = useState(value);

  return (
    <div className="relative flex items-center">
      <div className="absolute right-3">
        <SearchIcon />
      </div>
      <input
        type="search"
        placeholder="Search..."
        className="w-full h-12 rounded-lg p-3 satoshi-base-semibold-tabs border border-inputBorder focus:outline-none placeholder:satoshi-base-normal-inputBorder [&::-webkit-search-cancel-button]:hidden"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
    </div>
  );
};
